<template>
  <div id="app">
    <v-app id="inspire">
    <altaciklama ></altaciklama>
      <v-container fluid>
        <v-content>
          <v-layout row wrap>
            <v-flex pa-1 xs12 sm12 md12>
              <v-card flat class="white--text">
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-layout row wrap>
                      <v-layout row wrap>

                        <v-flex xs12 sm12 md12>


                          <v-layout align-center="" justify-start>
                            <v-icon large>people</v-icon>
                            <span class=" grey--text headline"> {{$t('Authority-Groups')}} </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout justify-end>
                            <v-divider></v-divider>
                          </v-layout>
                        </v-flex>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            <v-list>
                              <template>
                                <v-layout row wrap>
                                  <v-flex xs12 sm2 md2>
                                    <v-layout column="" align-start>
                                      <v-card flat="">
                                        <v-list-tile>
                                          <v-list-tile-content>
                                            <v-layout align-center>
                                              <v-flex>
                                                <v-list-tile-sub-title>
                                                  <v-layout column align-center>
                                                    {{ $t('Group-ID') }}
                                                  </v-layout>
                                                </v-list-tile-sub-title>
                                              </v-flex>
                                            </v-layout>
                                          </v-list-tile-content>
                                        </v-list-tile>
                                      </v-card>
                                    </v-layout>
                                  </v-flex>

                                  <v-flex xs12 sm4 md4>
                                    <v-layout column="" align-start>
                                      <v-card flat="">
                                        <v-list-tile>
                                          <v-list-tile-content>
                                            <v-layout align-center>
                                              <v-flex>
                                                <v-list-tile-sub-title>
                                                  <v-layout column align-center>
                                                    {{ $t('Group-Name') }}
                                                    </v-layout>
                                                </v-list-tile-sub-title>
                                              </v-flex>
                                            </v-layout>
                                          </v-list-tile-content>
                                        </v-list-tile>
                                      </v-card>
                                    </v-layout>
                                  </v-flex>

                                  <v-flex xs12 sm4 md4>
                                    <v-layout column="" align-start>
                                      <v-card flat="">
                                        <v-list-tile>
                                          <v-list-tile-content>
                                            <v-layout align-center>
                                              <v-flex>
                                                <v-list-tile-sub-title>
                                                  <v-layout column align-center>
                                                    {{$t('Main-Company')}}
                                                   </v-layout>
                                                </v-list-tile-sub-title>
                                              </v-flex>
                                            </v-layout>
                                          </v-list-tile-content>
                                        </v-list-tile>
                                      </v-card>
                                    </v-layout>
                                  </v-flex>

                                  <v-flex xs12 sm2 md2>
                                    <v-layout justify-end="" align-center>
                                      <v-card flat="">
                                        <v-list-tile>
                                          <v-list-tile-content>
                                            <v-layout justify-center="" align-center>
                                              <v-flex>
                                                <v-list-tile-sub-title>
                                                  <v-layout column justify-center="" align-center>
                                                    {{ $t('Process') }}
                                                  </v-layout>
                                                </v-list-tile-sub-title>
                                              </v-flex>
                                            </v-layout>
                                          </v-list-tile-content>
                                        </v-list-tile>
                                      </v-card>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                                <v-divider></v-divider>
                              </template>

                              <template v-for="item in sayfalist">
                                <v-layout row wrap v-bind:key="item.PageID">
                                  <v-flex xs12 sm2 md2>
                                    <v-layout column="" align-start>
                                      <v-card flat="">
                                        <v-list-tile>
                                          <v-list-tile-content>
                                            <v-layout align-center>
                                              <v-flex>
                                                <v-list-tile-sub-title>
                                                  <v-layout column align-center>
                                                    {{item.GroupID}}</v-layout>
                                                </v-list-tile-sub-title>
                                              </v-flex>
                                            </v-layout>

                                          </v-list-tile-content>
                                        </v-list-tile>
                                      </v-card>
                                    </v-layout>
                                  </v-flex>

                                  <v-flex xs12 sm4 md4>
                                    <v-layout column="" align-start>
                                      <v-card flat="">
                                        <v-list-tile>
                                          <v-list-tile-content>
                                            <v-layout align-center>
                                              <v-flex>
                                                <v-list-tile-sub-title>
                                                  <v-layout column align-center>
                                                    {{item.GroupName}}
                                                  </v-layout>
                                                </v-list-tile-sub-title>
                                              </v-flex>
                                            </v-layout>
                                          </v-list-tile-content>
                                        </v-list-tile>
                                      </v-card>
                                    </v-layout>
                                  </v-flex>

                                  <v-flex xs12 sm4 md4>
                                    <v-layout column="" align-start>
                                      <v-card flat="">
                                        <v-list-tile>
                                          <v-list-tile-content>
                                            <v-layout align-center>
                                              <v-flex>
                                                <v-list-tile-sub-title>
                                                  <v-layout column align-center>
                                                    {{item.CustomerName}}
                                                  </v-layout>
                                                </v-list-tile-sub-title>
                                              </v-flex>
                                            </v-layout>
                                          </v-list-tile-content>
                                        </v-list-tile>
                                      </v-card>
                                    </v-layout>
                                  </v-flex>

                                  <v-flex xs12 sm2 md2>
                                    <v-layout justify-end="" align-center row fill-height="">
                                      <v-card flat="">
                                        <v-list-tile>
                                          <v-list-tile-content>
                                            <v-layout align-center>
                                              <v-flex>
                                                <v-list-tile-sub-title>
                                                  <v-layout column align-center>
                                                    <v-layout>
                                                      <v-flex>
                                                        <v-btn small icon class="mx-0" @click="detayagit(item)">
                                                          <v-icon color="info">edit</v-icon>
                                                        </v-btn>
                                                      </v-flex>
                                                    </v-layout>

                                                  </v-layout>
                                                </v-list-tile-sub-title>
                                              </v-flex>
                                            </v-layout>
                                          </v-list-tile-content>
                                        </v-list-tile>
                                      </v-card>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                                <v-divider :key="item.id"></v-divider>
                              </template>
                            </v-list>
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>
          </v-layout>
        </v-content>
      </v-container>

      <navi v-model="drawer"></navi>

      <v-toolbar color="info" dark app :clipped-left="$vuetify.breakpoint.mdAndUp" fixed>
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
          <span class="hidden-sm-and-down">{{ $t('Authorization-Group-List')}}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <a target="_self" v-bind:href="'#/uye/yetkigrup/id?isl=yeni'">
          <v-btn v-if="kaydetbtn" flat> <span class="hidden-sm-and-down"> {{ $t('add-new-group') }} </span>
            <v-icon>add_box</v-icon>
          </v-btn>
        </a>
      </v-toolbar>
      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
        :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>
    </v-app>
  </div>

</template>

<script>
  import auth from '../../../../api/auth'
  import navi from "@/components/app/account/navigator.vue"
import altaciklama from "@/components/app/account/altaciklama.vue"
  import _ from 'underscore'
  import router from '../../../../router'
  import helpers from "@/components/app/customcomp/helpers.js"
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import bolumcomp from "@/components/app/bilet/partpage/bolumcomp.vue"
  import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"

  export default {
     data() {
        return {
      sayfalist: [],
      checkbox: true,

      WebGrup: {
        GroupID: null,
        GroupName: null,
        CustomerID: null,
        CustomerCode: null,
        CustomerName: null,
        PagesInfo: [],
      },

      sirketitems: [],
      detay: false,
      listeleme: true,
      active: null,
      UserInfo: {
        AdSoyad: null,
        Deleted: null,
        Email: null,
        GSM: null,
        KullaniciAdi: null,
        Sifre: null,
        UserID: null
      },
      yetkilist: [],
      listegorunum: true,
      islem: false,
      ManageInfo: {
        UserInfo: {
          UserID: null,
          AdSoyad: null,
          KullaniciAdi: null,
          Email: null,
          GSM: null,
          Sifre: null,
          Deleted: false,
        },
        AnaSirketInfo: []
      },

      WebUserAnaSirket: {
        MusteriID: null,
        MusteriKod: null,
        MusteriUnvan: null,
        UserTip: 0,
        Aktif: false
      },

      kaydetbtn: false,
      guncellebtn: false,
      eklebtn: true,
      itemseklenen: [],
      yedekresponse: [],
      bekle: false,
      AnaSirketlerWiev: [],
      AnaSirketler: [],
      Sirketler: [],
      AnaSirket: {},
      Sirket: {},
      giris: true,
      Urunler: false,
      urunlerlist: [],
      active: false,
      sektor: '0',
      uyeliktipi: '0',
      productshow: [],
      odemetipi: false,
      havale: true,
      kredikarti: false,
      odemeekrani: false,
      toplamtutar: 0,
      urunekrani: true,
      musteriid: null,
      dialogyenisirket: false,
      yenisirketunvani: null,
      sirkettipi: '0',
      karttipi: [{
          id: 'M',
          text: 'Master Card'
        },
        {
          id: 'VI',
          text: 'VISA'
        },
        {
          id: 'A',
          text: 'American Express'
        },
      ],
      sonkullanimAy: [{
          id: '01',
          text: '1'
        },
        {
          id: '02',
          text: '2'
        },
        {
          id: '03',
          text: '3'
        },
        {
          id: '04',
          text: '4'
        },
        {
          id: '05',
          text: '5'
        },
        {
          id: '06',
          text: '6'
        },
        {
          id: '07',
          text: '7'
        },
        {
          id: '08',
          text: '8'
        },
        {
          id: '09',
          text: '9'
        },
        {
          id: '10',
          text: '10'
        },
        {
          id: '11',
          text: '11'
        },
        {
          id: '12',
          text: '12'
        }
      ],
      sonkullanimYil: [
        '2005', '2006', '2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015',
        '2016', '2017',
        '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028',
        '2029', '2030'
      ],
      dictionary: {
        custom: {
          kartno: {
            required: () => this.$t('This-space-cannot-left-blank'),
            min: this.$t('Card-Number-Must-16-Digits')
          },

          selectkarttipi: {
            required: () => this.$t('Please-choose'),
          },
          kartcari: {
            required: () => this.$t('Please-choose'),
          },
          selectsonkullanim: {
            required: () => this.$t('Please-choose'),
          },
          selectsonkullanimyil: {
            required: () => this.$t('Please-choose'),
          },

        }
      },

      itemsnavi: [{
          icon: 'business',
          text: this.$t('Corporate-transactions'),
          to: 'anasirket',
        },
        {
          icon: 'people',
          text: this.$t('Member-Transactions'),
          to: 'login-uye'
        },

      ],
      clipped: true,
      drawer: true,
      fixed: false,
      miniVariant: false,
      right: true,
      rightDrawer: false,
      UrunKayit: {
        ID: null,
        MusteriInfo: {
          MusteriID: null,
          MusteriKod: null
        },
        UrunInfo: {
          UrunID: null
        },
        UrunAdet: 1,
        BaslangicTarih: null,
        BitisTarih: null,
        Kontor: null,
        KalanKontor: null,
        SatisTarihi: null,
        SatisTutar: 0,
        Aktif: null,
        OdemeOnay: 'false'
      },

      mevcutsirketmi: true,
      yenisirket: false,
      dialog: false,
      items: [{
          icon: 'domain',
          text: this.$t('Corporate-transactions')
        },
        {
          icon: 'contacts',
          text: this.$t('Member-Transactions')
        },
      ],


      faturainfo: [],
      newuserstatus: false,
      loginstatus: true,
      drawer: null,
      e1: 0,
      e2: true,
      e3: true,
      e4: true,
      text1: '',
      snackbar: false,
      y: 'top',
      x: 'right',
      mode: '',
      timeout: 6000,
      rules: {
        required: (value) => !!value || this.$t('Mandatory-Areas'),
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || this.$t('Wrong-e-mail')
        }
      },
      YeniKullanici: {
        UserID: null,
        MusteriID: 0,
        KullaniciAdi: null,
        Email: null,
        Sifre: null,
        Tip: 0,
        AdSoyad: null,
        Deleted: false,
        Aktif: false,
        MusteriBilgi: [],
        OdemeOnay: false,
      },
      unvan: null,
      confirm: null,
      Credential: {
        email: '',
        password: ''
      },
      valid: true,
      errorMsg: '',
      errorAlert: false,
      }
    },
    props: {
      source: String
    },
    methods: {
      logout() {
        auth.logout()
      },
      yenikullanicikaydet() {

        var sayfayetkilist = []
        if (this.WebGrup.CustomerID != null && this.WebGrup.GroupName) {

          this.sayfalist.forEach(element => {

            var sil = document.getElementsByName('sil' + element.PageID)
            var ekran = document.getElementsByName('ekran' + element.PageID)
            var guncelle = document.getElementsByName('guncelle' + element.PageID)
            var kaydet = document.getElementsByName('kaydet' + element.PageID)

            var yetkilist = {
              PageName: element.PageName,
              Screen: ekran[1].checked,
              Update: guncelle[1].checked,
              Delete: sil[1].checked,
              Save: kaydet[1].checked
            }
            sayfayetkilist.push(yetkilist)
          });

          this.WebGrup.PagesInfo = sayfayetkilist

          var groupparams = this.WebGrup

          this.$http.post(auth.API_URL + 'api/RegisterAuth/WebPageGroupSave', groupparams, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true
            if (response.body.Status == true) {
              var url = '#/uye/index'
              setTimeout(function () {
                window.open(url, '_self')
              }.bind(this), 5000)
            }
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable-WebUserManageSave'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable-WebUserManageSave'
              this.snackbar = true
            }
          })
        } else {
          this.text1=this.$t('Please-Enter-Complete-Group-Information')
          this.snackbar = true
        }
      },
      listesil(val) {

        for (var i = 0; i < this.itemseklenen.length; i++) {
          if (this.itemseklenen[i].MusteriKod == val.MusteriKod) {
            this.itemseklenen.splice(i, 1);
          }
        }
      },
      listeyeekle() {
        var kayitvarmi = this.itemseklenen.map(function (e) {
          return e.MusteriKod;
        }).indexOf(this.WebUserAnaSirket.MusteriKod);

        if (this.AnaSirket != null && typeof (this.AnaSirket) != 'object') {
          if (kayitvarmi === -1) {
            var yenikayit = {
              MusteriID: this.WebUserAnaSirket.MusteriID,
              MusteriKod: this.WebUserAnaSirket.MusteriKod,
              MusteriUnvan: this.WebUserAnaSirket.MusteriUnvan,
              UserTip: this.WebUserAnaSirket.UserTip,
              Aktif: this.WebUserAnaSirket.Aktif,
              Masraf: this.WebUserAnaSirket.Masraf,
              Referans: this.WebUserAnaSirket.Referans,
              Bolum: this.WebUserAnaSirket.Bolum
            }
            this.itemseklenen.push(yenikayit)
          } else {
            this.text1 = this.$t('Record-not-included-list')
            this.snackbar = true
          }
        } else {
          this.text1 = this.$t('Select-Your-Main-Company')
          this.snackbar = true
        }
      },
      detayagit(val) {

        if (val != null) {
          var url = '#/uye/yetkigrup/id?isl=guncelle&cid=' + val.CustomerID + '&gid=' + val.GroupID
          window.open(url, '_self')
        } else {
          this.text1 = 'Ana Şirket  Bulunamadı'
          this.snackbar = true
        }
      },
      yenisirketac() {
        this.bekle = true;
        var response1 = JSON.parse(window.localStorage.getItem('response'));
        if (this.yenisirketunvani != null && this.yenisirketunvani != '') {
          var params = {
            Mail: response1.Email,
            CustomerInfo: {
              Ad: this.yenisirketunvani
            }
          }

          this.$http.post(auth.API_URL + 'api/Register/NewCustomerAdd', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true
            if (response.body.Status == true) {
              this.text1 = this.$t('company-has-allocated-free-10-day')
              this.snackbar = true
              this.dialogyenisirket = false;
              this.sirkettipi = '0';
              this.bekle = false;
              var params = {
                Email: response1.Email

              }
              this.$http.post(auth.API_URL + 'api/Register/WebUserList', params, {
                headers: {
                  'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
              }).then((response) => {
                this.bekle = false;
                this.yedekresponse = response1
                window.localStorage.removeItem('response')
                var sirketlers = []

                Object.keys(response.body[0].MusteriBilgi).forEach(key => {
                  var anasirket = {
                    Ad: response.body[0].MusteriBilgi[key].Ad,
                    GenelSirketler: response.body[0].MusteriBilgi[key].Sirketler,
                    MusteriId: response.body[0].MusteriBilgi[key].MusteriID,
                    MusteriKod: response.body[0].MusteriBilgi[key].MusteriKod
                  }
                  sirketlers.push(anasirket)
                });

                var newresponse = {
                  AdSoyad: this.yedekresponse.AdSoyad,
                  Email: this.yedekresponse.Email,
                  MusteriDbler: sirketlers,
                  Token: this.yedekresponse.Token,
                  UserId: this.yedekresponse.UserId
                }

                //yeni response oluşturuldu

                window.localStorage.setItem('response', JSON.stringify(newresponse));

                sirketlers = []
                // yeni response ile tüm kartları güncelleyelim

                var yeniresponse = JSON.parse(window.localStorage.getItem('response'));


                yeniresponse.MusteriDbler.forEach(element => {

                  var sirket = {
                    text: element.Ad,
                    id: element.MusteriKod,
                    baglisirketler: element.GenelSirketler
                  }
                  sirketlers.push(sirket)

                });

                this.AnaSirketler = sirketlers;
                this.AnaSirketlerWiev = [];

                var yedeklist = []

                this.AnaSirketler.forEach(element => {
                  var id = element.id;
                  var text = element.text;
                  var baglisirket = [];
                  baglisirket = element.baglisirketler
                  var params = {
                    MusteriInfo: {
                      MusteriKod: element.id
                    }
                  }

                  this.$http.post(auth.API_URL +
                    'api/Register/ProductCustomerInfo', params, {
                      headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                      }
                    }).then((response) => {

                    var sirket = {
                      id: id,
                      text: text,
                      UyelikBitis: response.body.UyelikBitis,
                      UyelikTip: response.body.UyelikTip,
                      KalanKontor: response.body.KalanKontor,
                      UyelikStatus: response.body.UyelikStatus,
                      baglisirketler: baglisirket
                    }


                    yedeklist.push(sirket)

                  }, (response) => {
                    if (response.status === 0) {
                      this.text1 =
                        'Service Unavailable-Company Get'
                      this.bekle = false;

                      this.snackbar = true

                    } else {

                      this.text1 =
                        'Service Unavailable-Company Get'
                      this.snackbar = true

                    }
                  })

                });

                this.AnaSirketlerWiev = yedeklist

              }, (response) => {
                if (response.status === 0) {
                  this.bekle = false;

                  this.text1 = 'Service Unavailable-WebUserList'
                  this.snackbar = true
                } else {
                  this.text1 = 'Service Unavailable-WebUserList'
                  this.snackbar = true
                }
              })
            }

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable-NewCustomerAdd'
              this.bekle = false;

              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable-NewCustomerAdd'
              this.bekle = false;

              this.snackbar = true
            }
          })

        } else {
          this.text1 = this.$t('Please-enter-corporate-title')
          this.snackbar = true
          this.bekle = false;

        }
      },
      sirketaciptal() {
        this.dialogyenisirket = false;
        this.sirkettipi = '0';
      },
      urunleredon() {
        this.urunekrani = true;
        this.odemeekrani = false;
      },
      sirketleredon() {
        this.Urunler = false;
        this.giris = true;
      },

      Odeme(urunid, fiyat) {
        this.UrunKayit.UrunInfo.UrunID = urunid
        this.UrunKayit.SatisTutar = fiyat


        this.toplamtutar = fiyat;
        this.odemeekrani = true;
        this.urunekrani = false;
      },
      SatinAl() {
        this.UrunKayit.SatisTarihi = getDateNow()
        this.UrunKayit.MusteriInfo.MusteriKod = this.musteriid
        var params = this.UrunKayit
        this.$http.post(auth.API_URL + 'api/Register/ProductCustomerSave', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true
          if (response.body.Status == true) {
            this.text1 = this.$t('Payment-successful-you-being-redirected-page')
            this.snackbar = true

            this.guncelle();
            setTimeout(function () {

              this.odemeekrani = false;
              this.urunekrani = true;
              this.giris = true;
              this.Urunler = false;
            }.bind(this), 5000)
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-ProductCustomerSave'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-ProductCustomerSave'
            this.snackbar = true
          }
        })
      },
      urunleregit() {
        this.giris = false
        this.Urunler = true
        var params = {
          ProductID: 0,
          ProductType: 0
        }

        this.$http.post(auth.API_URL + 'api/Register/ProductList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.urunlerlist = response.body
          this.productshow = [];
          this.urunlerlist.forEach(element => {
            if (element.UrunTip == 2)
              this.productshow.push(element)
          });
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Company Get'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Company Get'
            this.snackbar = true
          }
        })
      },
      apiLogin,
      sysLogin,
      getDateNow,
      guncelle,
      userlist
    },
    beforeMount: beforeMount,
    components: {
      navi,
      referansmerkezicomp,
      masrafmerkezicomp,
      bolumcomp,
      altaciklama
    },

    watch: {
      'uyeliktipi': function (value) {
        if (value == 0) {
          this.productshow = [];
          this.urunlerlist.forEach(element => {
            if (element.UrunTip == 2)
              this.productshow.push(element)
          });
        } else {
          this.productshow = [];
          this.urunlerlist.forEach(element => {
            if (element.UrunTip == 3)
              this.productshow.push(element)
          });
        }
      },
      'UrunKayit.OdemeOnay': function (value) {
        if (value == 'false') {
          this.havale = true;
          this.kredikarti = false;
        } else {
          this.havale = false;
          this.kredikarti = true;

        }
      },
      'AnaSirket': function (value) {

        if (value != null) {
          this.AnaSirketler.forEach(element => {
            if (element.MusteriKod == value) {
              this.WebGrup.CustomerID = element.MusteriID
            }
          });
        }
      },
      'sirkettipi': function (value) {
        if (value == '0') {
          this.mevcutsirketmi = true;
          this.yenisirket = false;
          this.dialogyenisirket = false;
        } else {
          this.dialogyenisirket = true;
          this.mevcutsirketmi = false;
          this.yenisirket = true;
        }
      }
    },
    filters: {
      dateformat: function (t) {
        var date = new Date(t);
        var fulldate = date.toLocaleDateString("tr-TR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
        return fulldate;
      },
      moneyformat: function (m) {
        return m.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      }
    },
  }

  function beforeMount() {

    var response1 = JSON.parse(window.localStorage.getItem('response'));

    var cl = [];

    response1.MusteriDbler.forEach(element => {
      cl.push(element.MusteriId)

    });


    var params = {
      GroupID: 0,
      CustomerID: 0,
      AuthList: false,
      CustomerList: cl
    }
    this.$http.post(auth.API_URL + 'api/RegisterAuth/WebPageGroupList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.sayfalist = response.body

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-WebPageGroupList'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-WebPageGroupList'
        this.snackbar = true
      }
    })

    //sıralanacak şirketler
    var response2 = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));

    this.AnaSirketler = helpers.yetkilisirketlerigetir(response2.AnaSirketInfo)

    this.kaydetbtn = true;
    this.guncellebtn = false;
  }

  function guncelle() {}

  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }

  function userlist() {

    var response = JSON.parse(window.localStorage.getItem('response'));

    var userparams = {
      Email: response.Email
    }

    this.$http.post(auth.API_URL + 'api/Register/WebUserConnList', userparams, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-WebUserConnList'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-WebUserConnList'
        this.snackbar = true
      }
    })

  }


  function kullaniciKaydet() {

    var response = JSON.parse(window.localStorage.getItem('response'));

    this.ManageInfo.UserInfo.KullaniciAdi = 'user1'
    this.ManageInfo.UserInfo = '123456'
    var userparams = this.ManageInfo
    this.$http.post(auth.API_URL + 'api/Register/WebUserManageSave', userparams, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-WebUserConnList'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-WebUserConnList'
        this.snackbar = true
      }
    })

  }


  function apiLogin() {
    var credential = {
      Email: this.Credential.email,
      Password: this.Credential.password
    }
    auth.login(this, credential, this.$route.query.redirect)
  }

  function sysLogin(anasirketid, sirketler) {

    var response = JSON.parse(window.localStorage.getItem('response'));
    window.localStorage.setItem('token', response.Token.token);
    var earsiv = 0
    var efatura = 0
    this.Sirket.id = sirketler[0].SirketKodu
    this.Sirket.text = sirketler[0].SirketAdi
    this.Sirket.unvan = sirketler[0].SirketUnvani

    var sirketparams = {
      SirketKodu: this.Sirket.id
    }

    this.$http.post(auth.API_URL + 'api/Parameters/CompanyGet', sirketparams, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      earsiv = response.body.OpsiyonBilgileri.EArsiv
      efatura = response.body.OpsiyonBilgileri.EFaturaKullaniyor

      var credentials = {
        AnaSirketKodu: anasirketid,
        SirketKodu: this.Sirket.id,
        SirketAdi: this.Sirket.text,
        SirketUnvani: this.Sirket.unvan,
        Sirketler: sirketler,
        EArsiv: earsiv,
        EFatura: efatura,
        CoperSirketNo: 0
      }

      window.localStorage.setItem('credentials', JSON.stringify(credentials));

      window.localStorage.removeItem('response')
      router.push({
        path: '/'
      })


    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Company Get'
        this.snackbar = true
        this.load1 = true
        this.progress = false

        var credentials = {
          AnaSirketKodu: this.AnaSirket.id,
          SirketKodu: this.Sirket.id,
          SirketAdi: this.Sirket.text,
          SirketUnvani: this.Sirket.unvan,
          Sirketler: sirketler,
          EArsiv: earsiv,
          EFatura: efatura,
          CoperSirketNo: 0
        }

      } else {

        this.text1 = 'Service Unavailable-Company Get'
        this.snackbar = true
        this.load1 = true
        this.progress = false
        var credentials = {
          AnaSirketKodu: this.AnaSirket.id,
          SirketKodu: this.Sirket.id,
          SirketAdi: this.Sirket.text,
          SirketUnvani: this.Sirket.unvan,
          Sirketler: sirketler,
          EArsiv: earsiv,
          EFatura: efatura,
          CoperSirketNo: 0
        }
      }
      window.localStorage.removeItem('response')
      window.localStorage.removeItem('sirketler')
      router.push({
        path: '/'
      })
    })
  }
</script>